import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { Button } from 'src/registry/ui/Button';
import { ICON_MAP } from 'src/utils/constants';
import { commonMessages } from 'src/utils/messages';

const BackButton = () => {
    const { formatMessage } = useIntl();
    const navigate = useNavigate();

    return (
        <Button className="-mt-6 cursor-pointer place-self-start p-0" variant="link" onClick={() => navigate(-1)}>
            <>
                <FontAwesomeIcon icon={ICON_MAP.BACK} className="opacity-50" />
                {formatMessage(commonMessages.back)}
            </>
        </Button>
    );
};

export default BackButton;
